import React, { useState, useEffect, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './TestCalender.css';
import dayjs from 'dayjs';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MedicRecordBox from '../../../../components/box/MedicRecordBox';
import HealthRecordBox from '../../../../components/box/HealthRecordBox';
import EmotionRecordBox from '../../../../components/box/EmotionRecordBox';
import ImgNoData from '../../../../images/common/i_3d_no_data_doc.svg';
import URL from '../../../../constants/url';
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../../../../components/comm/Modal';

import ToastPopup from '../../../../components/comm/ToastPopup';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import congratsLottie from "../../../../assets/lottiefiles/congrats.lottie";

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';

import data_01 from '../survey/01/data_01.json';
import data_02 from '../survey/02/data_02.json';
import data_03 from '../survey/03/data_03.json';
import data_04 from '../survey/04/data_04.json';
import data_05 from '../survey/05/data_05.json';
import data_06 from '../survey/06/data_06.json';
import data_07 from '../survey/07/data_07.json';
import data_08 from '../survey/08/data_08.json';
import data_09 from '../survey/09/data_09.json';
import data_10 from '../survey/10/data_10.json';
import data_11 from '../survey/11/data_11.json';
import data_15 from '../survey/15/data_15.json';
import data_16 from '../survey/16/data_16.json';
import data_17 from '../survey/17/data_17.json';
import data_18 from '../survey/18/data_18.json';
import data_19 from '../survey/19/data_19.json';
import data_20 from '../survey/20/data_20.json';
import data_21 from '../survey/21/data_21.json';
import data_22 from '../survey/22/data_22.json';
import data_23 from '../survey/23/data_23.json';
import data_24 from '../survey/24/data_24.json';
import data_25 from '../survey/25/data_25.json';
import data_26 from '../survey/26/data_26.json';
import data_27 from '../survey/27/data_27.json';
import data_28 from '../survey/28/data_28.json';

import { formatDateToYYMMDD, getDayKoreanLetter } from '../../../../hook/dateUtils';

const surveyDataMap = {
    0: { url: URL.SURVEY_CUSTOM },
    1: { data: data_01, url: URL.SURVEY_01 },
    2: { data: data_02, url: URL.SURVEY_02 },
    6: { data: data_03, url: URL.SURVEY_03 },
    4: { data: data_04, url: URL.SURVEY_04 },
    5: { data: data_05, url: URL.SURVEY_05 },
    7: { data: data_06, url: URL.SURVEY_06 },
    8: { data: data_07, url: URL.SURVEY_07 },
    9: { data: data_08, url: URL.SURVEY_08 },
    10: { data: data_09, url: URL.SURVEY_09 },
    11: { data: data_10, url: URL.SURVEY_10 },
    14: { data: data_11, url: URL.SURVEY_11 },
    15: { data: data_15, url: URL.SURVEY_15 },
    16: { data: data_16, url: URL.SURVEY_16 },
    17: { data: data_17, url: URL.SURVEY_17 },
    18: { data: data_18, url: URL.SURVEY_18 },
    19: { data: data_19, url: URL.SURVEY_19 },
    20: { data: data_20, url: URL.SURVEY_20 },
    21: { data: data_21, url: URL.SURVEY_21 },
    22: { data: data_22, url: URL.SURVEY_22 },
    23: { data: data_23, url: URL.SURVEY_23 },
    24: { data: data_24, url: URL.SURVEY_24 },
    25: { data: data_25, url: URL.SURVEY_25 },
    26: { data: data_26, url: URL.SURVEY_26 },
    27: { data: data_27, url: URL.SURVEY_27 },
    28: { data: data_28, url: URL.SURVEY_28 },
};

const getStatusColor = (status) => {
    switch (status) {
        case '모두완료':
            return 'all';
        case '일부완료':
            return 'most';
        case '미완료':
            return 'not';
        case 'none':
        case undefined:
        default:
            return 'none';
    }
};


const TestCalender = () => {
    const [confirmModal, setConfirmModal] = useState({ open: false, mode: null });
    const [value, setValue] = useState(new Date()); // 선택된 날짜
    const [activeStartDate, setActiveStartDate] = useState(new Date()); // 캘린더가 보여주는 월
    const [toast, setToast] = useState(false);
    // 건강 기록 관련 상태 (그대로 유지)
    const [healthRecordList, setHealthRecordList] = useState([]);
    const [healthDateStatusMap, setHealthDateStatusMap] = useState({});


    const [subType, setSubType] = useState(() => {
        return sessionStorage.getItem('calendarSubType') || "medicine";
    });



    const navigate = useNavigate();

    const [medicineRecordList, setMedicineRecordList] = useState({});
    const [medicineDateStatusMap, setMedicineDateStatusMap] = useState({});

    const [loading, setLoading] = useState(false);

    const tileClassName = ({ date, view }) =>
        view === 'month' && date.getDay() === 0 ? 'sunday' : null;

    const selectedDateStr = dayjs(value).format("YYYYMMDD");

    const selectedMedicineNotifications = medicineRecordList[selectedDateStr] || [];

    const selectedHealthRecords = healthRecordList[selectedDateStr];
    const selectedHealthStatus = healthDateStatusMap[selectedDateStr];

    const [pillFinishToast, setPillFinishToast] = useState(false);

    useEffect(() => {
        sessionStorage.setItem('calendarSubType', subType);
    }, [subType]);

    const checkWrite = (record) => {
        return record?.lastMarkVal != null;
    };
    const searchTakingMedicineRecordList = async (year, month) => {

        setLoading(true);
        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const requestUrl = "/homecare/tkmdcn/retrieveUserTakingMedicineRecordingMonthList";
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        const targetMonth = `${year}${String(month + 1).padStart(2, '0')}`;

        const requestBody = {
            usrInfoId: user?.usrInfoId,
            usrHsptlMap: user?.usrHsptlMap,
            targetMonth: targetMonth
        };

        try {
            const res = await axiosApi.post(requestUrl, requestBody, requestOption);
            const resultData = res.data;

            console.log('API 응답:', resultData); // 이 로그 추가


            if (resultData.resultCode === CODE.RCV_SUCCESS) {
                const allData = resultData.result.usrTkmdcnRecList || [];

                const transformedList = allData.map(item => {
                    const hour = item.alrmSetupTm ? parseInt(item.alrmSetupTm.substring(0, 2), 10) : 9;
                    const minute = item.alrmSetupTm ? parseInt(item.alrmSetupTm.substring(2, 4), 10) : 0;
                    const pillList = item.tkmdcnCn ? item.tkmdcnCn.split('@,@') : [];

                    return {
                        id: item.usrTkmedicnInfoId,
                        hour,
                        minute,
                        active: item.alrmAt === '1' ? 'Y' : 'N',
                        status: item.tkmdcnAt === '1' ? 'completed' : 'pending',
                        data: {
                            data: {
                                selectedTime: item.tkmdcnEraNm,
                                timing: item.tkmdcnMthCn || '',
                                pillList: pillList
                            }
                        },
                        body: item.tkmdcnCn,
                        ...item
                    };
                });

                const grouped = groupMedicineByDate(transformedList, year, month);
                const statusMap = computeMedicineDateStatus(grouped, year, month);

                // 매번 새로 세팅 (중복 방지)
                setMedicineRecordList(grouped);
                setMedicineDateStatusMap(statusMap);
            } else {
                setMedicineRecordList({});
                setMedicineDateStatusMap({});
            }
        } catch (err) {
            console.error("복약 기록 조회 중 오류", err);
            setMedicineRecordList({});
            setMedicineDateStatusMap({});
        } finally {
            setLoading(false);
        }
    };

    // const groupMedicineByDate = (medicineList, year, month) => {
    //     const grouped = {};

    //     medicineList.forEach(medicine => {
    //         const dateKey = medicine.tkmdcnDe;
    //         if (!dateKey) return;
    //         if (!grouped[dateKey]) {
    //             grouped[dateKey] = [];
    //         }
    //         grouped[dateKey].push(medicine);
    //     });

    //     return grouped;
    // };

    const groupMedicineByDate = (medicineList, year, month) => {
        const grouped = {};

        medicineList.forEach(medicine => {
            const dateKey = medicine.tkmdcnDe;
            if (!dateKey) return;

            // 기간 체크 추가
            const startDate = medicine.alrmSetupDe;
            const endDate = medicine.tkmdcnEndDe;

            if (dateKey < startDate || dateKey > endDate) {
                return; // 기간 밖이면 제외
            }

            if (!grouped[dateKey]) {
                grouped[dateKey] = [];
            }
            grouped[dateKey].push(medicine);
        });

        return grouped;
    };


    const computeMedicineDateStatus = (groupedMedicine, year, month) => {
        const statusMap = {};

        Object.keys(groupedMedicine).forEach(dateKey => {
            const medicines = groupedMedicine[dateKey];
            const allCompleted = medicines.every(m => m.tkmdcnAt === '1');
            const someCompleted = medicines.some(m => m.tkmdcnAt === '1');

            if (allCompleted) {
                statusMap[dateKey] = "모두완료";
            } else if (someCompleted) {
                statusMap[dateKey] = "일부완료";
            } else {
                statusMap[dateKey] = "미완료";
            }
        });

        return statusMap;
    };

    // 캘린더가 오늘이 있는 달로 이동
    const handleTodayClick = () => {
        const today = new Date();
        setValue(today);
        setActiveStartDate(today);
    };

    // const groupByDate = (records) => {
    //     return records.reduce((acc, record) => {
    //         const date = record.srveyBgnDe; // 날짜 컬럼
    //         if (!acc[date]) {
    //             acc[date] = [];
    //         }
    //         acc[date].push(record);
    //         return acc;
    //     }, {});
    // };

    const groupByDate = (records) => {
        return records.reduce((acc, record) => {
            const startDate = record.srveyBgnDe;
            const endDate = record.srveyEndDe;

            if (!startDate || !endDate) return acc;

            // 시작일 ~ 종료일 사이의 모든 날짜에 추가
            let currentDate = dayjs(startDate, "YYYYMMDD");
            const end = dayjs(endDate, "YYYYMMDD");

            while (currentDate.isBefore(end) || currentDate.isSame(end)) {
                const dateKey = currentDate.format("YYYYMMDD");

                if (!acc[dateKey]) {
                    acc[dateKey] = [];
                }
                acc[dateKey].push(record);

                currentDate = currentDate.add(1, 'day');
            }

            return acc;
        }, {});
    };

    // 날짜별 상태 데이터 계산
    const computeDateStatus = (groupedRecords, year, month) => {
        const statusMap = {};

        Object.keys(groupedRecords).forEach(dateKey => {
            const records = groupedRecords[dateKey];
            const results = records.map(record => checkWrite(record));
            const allTrue = results.every(Boolean);
            const anyTrue = results.some(Boolean);

            if (allTrue) {
                statusMap[dateKey] = "모두완료";
            } else if (anyTrue) {
                statusMap[dateKey] = "일부완료";
            } else {
                statusMap[dateKey] = "미완료";
            }
        });

        return statusMap;
    };

    const fetchResultData = async (year, month) => {

        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const url = "/homecare/srvey/retrieveUserHealthRecordsList";
        const jToken = localStorage.getItem('jToken');

        const startOfMonth = dayjs(new Date(year, month, 1)).format("YYYYMMDD");
        const endOfMonth = dayjs(new Date(year, month + 1, 0)).format("YYYYMMDD");

        const reqBody = {
            usrHsptlMap: loginUser.usrHsptlMap,
            recGbnVal: "BC",
            calGbnAt: "1",
            calStartDt: startOfMonth,
            calEndDt: endOfMonth
        };

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        };

        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            const resultList = res.data.result.resultList || [];

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const grouped = groupByDate(resultList);
                const statusMap = computeDateStatus(grouped, year, month);

                setHealthRecordList(grouped);
                setHealthDateStatusMap(statusMap);
            } else {
                setHealthRecordList({});
                setHealthDateStatusMap({});
            }
        } catch (err) {
            console.error("건강 기록 조회 중 오류", err);
            setHealthRecordList({});
            setHealthDateStatusMap({});
        }
    };

    const handleAllCheckClick = () => {
        const allChecked = selectedMedicineNotifications.every(notif => notif.tkmdcnAt === '1');

        if (allChecked) {
            // 전체 해제는 막음
            // setConfirmModal({ open: true, mode: "uncheckAll" });
        } else {
            setConfirmModal({ open: true, mode: "checkAll" });
        }
    };

    const handleConfirm = async () => {
        if (confirmModal.mode === "checkAll") {
            const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
            const jToken = localStorage.getItem("jToken");
            const url = "/homecare/tkmdcn/saveUserTakingMedicineRecordList";

            const reqBody = selectedMedicineNotifications.map(notif => ({
                usrTkmedicnInfoId: notif.usrTkmedicnInfoId,
                usrInfoId: loginUser.usrInfoId,
                tkmdcnDe: selectedDateStr
            }));

            const reqOptions = {
                headers: {
                    'Authorization': 'Bearer ' + jToken,
                }
            };

            try {
                const res = await axiosApi.post(url, reqBody, reqOptions);

                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    const year = activeStartDate.getFullYear();
                    const month = activeStartDate.getMonth();
                    searchTakingMedicineRecordList(year, month);
                } else {
                    alert("복약 기록 저장에 실패했습니다.");
                }
            } catch (err) {
                console.error("복약 기록 저장 중 오류", err);
                alert("복약 기록 저장에 실패했습니다.");
            }

        } else if (confirmModal.mode === "uncheckAll") {
            sessionStorage.removeItem('toastShown');
            const year = activeStartDate.getFullYear();
            const month = activeStartDate.getMonth();
            searchTakingMedicineRecordList(year, month);
        }

        setConfirmModal({ open: false, mode: null });
    };

    const meal_to_num = (meal) => {
        switch (meal) {
            case '아침': return '1';
            case '점심': return '2';
            case '저녁': return '3';
            default: return '1';
        }
    };

    const handleDateChange = (date) => {
        setValue(date);

        const dateKey = dayjs(date).format("YYYYMMDD");

        if (subType === "medicine") {
            const selectedData = medicineRecordList[dateKey] || [];
            console.log("📅 [복약기록 클릭일자]", dateKey, selectedData);
        } else {
            const selectedData = healthRecordList[dateKey] || [];
            console.log("📅 [건강기록 클릭일자]", dateKey, selectedData);
        }
    };


    const handleSingleCheck = async (usrTkmedicnInfoId, isChecked) => {
        if (!isChecked) {
            return;
        }

        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");
        const url = "/homecare/tkmdcn/saveUserTakingMedicineRecordList";

        const reqBody = [{
            usrTkmedicnInfoId: usrTkmedicnInfoId,
            usrInfoId: loginUser.usrInfoId,
            tkmdcnDe: selectedDateStr
        }];

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        };

        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const year = activeStartDate.getFullYear();
                const month = activeStartDate.getMonth();
                searchTakingMedicineRecordList(year, month);
            } else {
                alert("복약 기록 저장에 실패했습니다.");
            }
        } catch (err) {
            console.error("복약 기록 저장 중 오류", err);
            alert("복약 기록 저장에 실패했습니다.");
        }
    };

    useEffect(() => {
        const year = activeStartDate.getFullYear();
        const month = activeStartDate.getMonth();

        fetchResultData(year, month);
        searchTakingMedicineRecordList(year, month);
    }, [activeStartDate]);

    useEffect(() => {
        if (sessionStorage.getItem('showToast') === 'true') {
            setPillFinishToast(true); // 토스트 표시
            sessionStorage.removeItem('showToast'); // 한 번만 표시
        }
    }, []);

    return (
        <>
            <HeadSub title="전체 일정" />

            <div id="sub-content">

                {/*=== 캘린더 영역 ===*/}
                <div className="react-calender-wrap">
                    <Box sx={{ display: "flex" }} data-class-name="swich-btn-btn">
                        <Box className="mask-box">
                            <Box className="mask" style={{ transform: `translateX(${subType === "medicine" ? 0 : "var(--sp-wid-86)"})` }} />
                            <Button
                                disableRipple
                                variant="text"
                                sx={{ color: subType === "medicine" ? "#ffffff" : "var(--color-main-gray-10)" }}
                                onClick={() => setSubType("medicine")}
                                className={subType === "medicine" ? `active` : null}
                            >
                                복약기록
                            </Button>
                            <Button
                                disableRipple
                                variant="text"
                                sx={{ color: subType === "health" ? "#ffffff" : "var(--color-main-gray-10)" }}
                                onClick={() => setSubType("health")}
                                className={subType === "health" ? `active` : null}
                            >
                                건강기록
                            </Button>
                        </Box>
                    </Box>


                    <div className='calender-box'>
                        <div className='calender-legend'>
                            <span data-progress="4">모두 완료</span>
                            <span data-progress="3">일부 완료</span>
                            <span data-progress="2">미완료</span>
                            <span data-progress="1">남은 일정</span>
                        </div>



                        {subType === "medicine" ? (
                            <>
                                <Calendar
                                    locale="ko"
                                    // onChange={setValue}
                                    onChange={handleDateChange}
                                    value={value}
                                    navigationLabel={({ date }) => {
                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        return `${year}.${month}`;
                                    }}
                                    calendarType="hebrew"
                                    next2Label={null}
                                    prev2Label={null}
                                    activeStartDate={activeStartDate}
                                    onActiveStartDateChange={({ activeStartDate }) => {
                                        setActiveStartDate(activeStartDate);
                                        const firstDayOfMonth = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth(), 1);
                                        setValue(firstDayOfMonth);
                                    }}
                                    formatDay={(locale, date) => dayjs(date).format('D')}
                                    tileClassName={tileClassName}
                                    tileContent={({ date, view }) => {

                                        if (date.getMonth() !== activeStartDate.getMonth()) return null;

                                        const dateKey = dayjs(date).format("YYYYMMDD");
                                        const today = dayjs().format("YYYYMMDD");
                                        const status = medicineDateStatusMap[dateKey];
                                        const hasData = medicineRecordList[dateKey] && medicineRecordList[dateKey].length > 0;

                                        let finalStatus;

                                        if (loading) {
                                            // 자리를 유지하면서 로딩 애니메이션만 보여줌
                                            return <div className="status-bar" data-status="loading"></div>;
                                        }

                                        if (!hasData) {
                                            finalStatus = "none";
                                        } else if (dateKey > today) {
                                            finalStatus = "default";  // 오늘 이후는 남은 일정
                                        } else {
                                            finalStatus = getStatusColor(status);
                                        }

                                        return (
                                            <div className="status-bar" data-status={finalStatus}></div>
                                        );
                                    }}

                                />
                            </>
                        ) : (
                            <Calendar
                                locale="ko"
                                // onChange={setValue}
                                onChange={handleDateChange}

                                value={value}
                                navigationLabel={({ date }) => {
                                    const year = date.getFullYear();
                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                    return `${year}.${month}`;
                                }}
                                calendarType="hebrew"
                                next2Label={null}
                                prev2Label={null}
                                activeStartDate={activeStartDate}
                                onActiveStartDateChange={({ activeStartDate }) => {
                                    setActiveStartDate(activeStartDate);
                                    const firstDayOfMonth = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth(), 1);
                                    setValue(firstDayOfMonth);
                                }}
                                formatDay={(locale, date) => dayjs(date).format('D')}
                                tileClassName={tileClassName}
                                tileContent={({ date, view }) => {
                                    if (date.getMonth() !== activeStartDate.getMonth()) return null;

                                    const dateKey = dayjs(date).format("YYYYMMDD");
                                    const today = dayjs().format("YYYYMMDD");
                                    const status = healthDateStatusMap[dateKey];
                                    const hasData = healthRecordList[dateKey] && healthRecordList[dateKey].length > 0;

                                    let finalStatus;

                                    if (loading) {
                                        // 자리를 유지하면서 로딩 애니메이션만 보여줌
                                        return <div className="status-bar" data-status="loading"></div>;
                                    }

                                    if (!hasData) {
                                        finalStatus = "none";
                                    } else if (dateKey > today) {
                                        finalStatus = "default";
                                    } else {
                                        finalStatus = getStatusColor(status);
                                    }

                                    return (
                                        <div className='status-bar' data-status={finalStatus}></div>
                                    );
                                }}
                            />
                        )}

                        {subType === "medicine" && (<button type='button' className='btn' onClick={() => navigate(URL.PILL_ADD)}>복약 추가</button>)}
                        <button type='button' className='btn' onClick={handleTodayClick} >오늘</button>
                    </div>
                </div>


                {/*==== 하단 영역 ====*/}

                {/* 복약 기록 */}
                <div className="bottom-record-wrap">
                    <div className='inner-wrap' data-pad="normal">
                        <div className="record-head-title">
                            <div className='record-head-sub-title'>
                                <p className="record-date">
                                    {formatDateToYYMMDD(value)}({getDayKoreanLetter(value)})
                                </p>
                                <p>
                                    {loading ? (
                                        <Skeleton variant="text" width={35} style={{ borderRadius: "4px" }} />
                                    ) : (
                                        <>
                                            {subType === "medicine"
                                                ? selectedMedicineNotifications.length
                                                : (selectedHealthRecords?.length ?? 0)
                                            }
                                            건
                                        </>
                                    )}
                                </p>


                                {loading ? (
                                    <Skeleton variant="text" width={45} height={26} style={{ borderRadius: "10px" }} />
                                ) : (
                                    <>
                                        {subType === "medicine" ? (
                                            (() => {
                                                const status = medicineDateStatusMap[selectedDateStr];
                                                const today = dayjs().format("YYYYMMDD");
                                                const hasData = selectedMedicineNotifications.length > 0;

                                                let displayStatus = status || '남은 일정';
                                                let dataStatus = '4';

                                                if (hasData && selectedDateStr > today) {
                                                    displayStatus = '남은 일정';
                                                    dataStatus = '1';
                                                } else if (status === '모두완료') {
                                                    dataStatus = '4';
                                                } else if (status === '일부완료') {
                                                    dataStatus = '2';
                                                } else if (status === '미완료') {
                                                    dataStatus = '3';
                                                }

                                                return (
                                                    <span data-status={dataStatus}>
                                                        {displayStatus}
                                                    </span>
                                                );
                                            })()
                                        ) : (
                                            (() => {
                                                const status = selectedHealthStatus;
                                                const today = dayjs().format("YYYYMMDD");
                                                const hasData = selectedHealthRecords && selectedHealthRecords.length > 0;

                                                if (!hasData) return null;

                                                let displayStatus = status || '남은 일정';
                                                let dataStatus = '4';

                                                if (selectedDateStr > today) {
                                                    displayStatus = '남은 일정';
                                                    dataStatus = '1';
                                                } else if (status === '모두완료') {
                                                    dataStatus = '4';
                                                } else if (status === '일부완료') {
                                                    dataStatus = '2';
                                                } else if (status === '미완료') {
                                                    dataStatus = '3';
                                                }

                                                return (
                                                    <span data-status={dataStatus}>
                                                        {displayStatus}
                                                    </span>
                                                );
                                            })()
                                        )}
                                    </>
                                )}
                            </div>


                            {subType === 'medicine' && selectedDateStr <= dayjs().format("YYYYMMDD") &&
                                <div className="chkbox-custom" data-chkbox="all-btn">
                                    <input
                                        type="checkbox"
                                        id="all-btn"
                                        checked={selectedMedicineNotifications.length > 0 && selectedMedicineNotifications.every(notif => notif.tkmdcnAt === '1')}
                                        onChange={handleAllCheckClick}
                                    />
                                    <label htmlFor="all-btn">모두 완료</label>
                                </div>
                            }
                        </div>

                        <div className="record-lists">

                            {loading ? (
                                <>
                                    {[1, 2].map((item) => (
                                        <div className='calender-skeleton-box' key={item}>
                                            <div className='skeleton-box-top'>
                                                <Skeleton variant="text" width="30%" />
                                                <Skeleton variant="text" width="30%" />
                                            </div>
                                            <Skeleton variant="text" width="50%" />
                                            <Skeleton variant="text" width="30%" />
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <>
                                    {subType === "medicine" ? (
                                        <>
                                            {selectedMedicineNotifications && selectedMedicineNotifications.length > 0 ? (
                                                selectedMedicineNotifications.map((item, index) => (
                                                    <MedicRecordBox
                                                        key={item.id}
                                                        // key={item.usrTkmedicnInfoId}  // 변경
                                                        item={item}
                                                        index={index}
                                                        pillName="처방 외 복용하는"
                                                        chkDay={meal_to_num(item?.data?.data?.selectedTime)}
                                                        pillType="user"
                                                        checked={item.tkmdcnAt === '1'}
                                                        onCheckChange={handleSingleCheck}
                                                    />
                                                ))
                                            ) : (
                                                <div className='no-record-lists-data'>
                                                    <div className='img-box'>
                                                        <object data={ImgNoData}></object>
                                                    </div>
                                                    <p>일정이 없습니다.</p>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {selectedHealthRecords && selectedHealthRecords.length > 0 ? (
                                                selectedHealthRecords.map((record) => {

                                                    let surveyData = {};
                                                    //고정:05 /맞춤:06
                                                    if(record.cntsSeCd === '05') {
                                                        const mapped = surveyDataMap[record.srveyMngId];
                                                        surveyData = { ...mapped.data[0], url: mapped.url, item: record } || {};
                                                    } else if(record.cntsSeCd === '06') {
                                                        surveyData = { url: surveyDataMap[0].url, item: record } || {};
                                                    }

                                                    return (
                                                        <HealthRecordBox
                                                            key={record.usrSrveyRsltId}
                                                            title={record.srveySj}
                                                            write={checkWrite(record)}
                                                            usrSrveyRsltId={record.usrSrveyRsltId}
                                                            date={selectedDateStr}
                                                            surveyData={surveyData}
                                                            alarmChk={record.alrmAt}
                                                        />
                                                    );
                                                })
                                            ) : (
                                                <div className='no-record-lists-data'>
                                                    <div className='img-box'>
                                                        <object data={ImgNoData}></object>
                                                    </div>
                                                    <p>일정이 없습니다.</p>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>

            </div>

            {toast && (
                <>
                    <ToastPopup
                        setToast={setToast}
                        message={'오늘 복약 모두 완료!'}
                        position="center"
                        opacity="90"
                    />
                    <div className='lottie-box'>
                        <DotLottieReact
                            src={congratsLottie}
                            loop
                            autoplay
                        />
                    </div>
                </>
            )}

            {pillFinishToast && (
                <ToastPopup
                    setToast={setPillFinishToast}
                    message="추가 완료!"
                    position="center"
                    opacity="90"
                />
            )}

            <Modal isOpen={confirmModal.open} setIsOpen={() => setConfirmModal({ open: false, mode: null })}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            {confirmModal.mode === "checkAll" ? (
                                <p>복약을 모두 완료하셨나요?</p>
                            ) : (
                                <p>복약 기록을 모두 취소하시겠어요?</p>
                            )}
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button
                                className="btn"
                                data-btn-type="outline-main"
                                data-btn-size="md"
                                onClick={() => setConfirmModal({ open: false, mode: null })}
                            >
                                <span>아니오</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={handleConfirm}
                            >
                                <span>
                                    {confirmModal.mode === "checkAll" ? "네,완료했어요" : "네,취소할께요"}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default TestCalender;
